var module = angular.module('octopusApp.shared');

module.controller('TemplateParameterEditController', function ($scope, busy, $uibModalInstance, title, parameter, invalidStepTypes, names, requiredPermission, projectId) {
    var isSaving = $scope.isSaving = busy.create();
    $scope.title = title;
    $scope.parameter = parameter;
    $scope.invalidStepTypes = invalidStepTypes;
    $scope.requiredPermission = requiredPermission;
    $scope.projectId = projectId;

    $scope.controlTypes = {
        "SingleLineText": "Single-line text box",
        "MultiLineText": "Multi-line text box",
        "Select": "Drop down",
        "Checkbox": "Checkbox",
        "Sensitive": "Sensitive/password box",
        "StepName": "A previous deployment step name",
        "AzureAccount": "Azure Account"
    };
    
    if (!$scope.parameter.DisplaySettings) {
        $scope.parameter.DisplaySettings = {};
        $scope.parameter.DisplaySettings['Octopus.ControlType'] = 'SingleLineText';
    }

    $scope.close = function () {
        if (!parameter.Name || parameter.Name === '') {
            isSaving.showError('Please provide a variable name for the parameter.');
            return;
        }
        if (_.contains(names, parameter.Name)) {
            isSaving.showError('This parameter variable name is already in use. Please provide a unique name.');
            return;
        }
        $uibModalInstance.close(parameter);
    };

    $scope.cancel = function () {
        $uibModalInstance.close();
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/controllers/template_edit_parameter_controller.js
// module id = 582
// module chunks = 1